import Vue from 'vue'
import VueRouter from 'vue-router'

Vue.use(VueRouter)

const routes = [

  {
    path: '/Home',
    name: 'Home',
    // route level code-splitting
    // this generates a separate chunk (about.[hash].js) for this route
    // which is lazy-loaded when the route is visited.
    component: () => import(/* webpackChunkName: "about" */ '../views/Home.vue'),
    meta: {
      title: '个人中心'
    }
  },
  {
    path: '/Order',
    name: 'Order',
    // route level code-splitting
    // this generates a separate chunk (about.[hash].js) for this route
    // which is lazy-loaded when the route is visited.
    component: () => import(/* webpackChunkName: "about" */ '../views/Order.vue'),
    meta: {
      title: '购买/续费'
    }
  },
  {
    path: '/dingdan',
    name: 'dingdan',
    // route level code-splitting
    // this generates a separate chunk (about.[hash].js) for this route
    // which is lazy-loaded when the route is visited.
    component: () => import(/* webpackChunkName: "about" */ '../views/dingdan.vue'),
    meta: {
      title: '我的订单'
    }
  },
  {
    path: '/saoyisao',
    name: 'saoyisao',
    // route level code-splitting
    // this generates a separate chunk (about.[hash].js) for this route
    // which is lazy-loaded when the route is visited.
    component: () => import(/* webpackChunkName: "about" */ '../views/saoyisao.vue'),
    meta: {
      title: '扫一扫'
    }
  },
  {
    path: '/dengru',
    name: 'dengru',
    // route level code-splitting
    // this generates a separate chunk (about.[hash].js) for this route
    // which is lazy-loaded when the route is visited.
    component: () => import(/* webpackChunkName: "about" */ '../views/dengru.vue'),
    meta: {
      title: '登入'
    }
  },{
    path: '/zhuye',
    name: 'zhuye',
    // route level code-splitting
    // this generates a separate chunk (about.[hash].js) for this route
    // which is lazy-loaded when the route is visited.
    component: () => import(/* webpackChunkName: "about" */ '../views/zhuye.vue'),
    meta: {
      title: '管理页面'
    }
  },{
    path: '/tishi',
    name: 'tishi',
    // route level code-splitting
    // this generates a separate chunk (about.[hash].js) for this route
    // which is lazy-loaded when the route is visited.
    component: () => import(/* webpackChunkName: "about" */ '../views/tishi.vue'),
    meta: {
      title: '购买/续费'
    }
  },{
    path: '/guanyu',
    name: 'guanyu',
    // route level code-splitting
    // this generates a separate chunk (about.[hash].js) for this route
    // which is lazy-loaded when the route is visited.
    component: () => import(/* webpackChunkName: "about" */ '../views/guanyu.vue'),
    meta: {
      title: '关于我们'
    }
  },{
    path: '/hezuo',
    name: 'hezuo',
    // route level code-splitting
    // this generates a separate chunk (about.[hash].js) for this route
    // which is lazy-loaded when the route is visited.
    component: () => import(/* webpackChunkName: "about" */ '../views/hezuo.vue'),
    meta: {
      title: '商务合作'
    }
  },{
    path: '/tgxq',
    name: 'tgxq',
    // route level code-splitting
    // this generates a separate chunk (about.[hash].js) for this route
    // which is lazy-loaded when the route is visited.
    component: () => import(/* webpackChunkName: "about" */ '../views/tgxq.vue'),
    meta: {
      title: '活动推广'
    }
  }
]

const router = new VueRouter({
  mode: 'history',
  base: process.env.BASE_URL,
  routes
})

router.beforeEach((to, from, next)=>{

  if (to.path === '/dengru' || to.path === '/saoyisao' || to.path === '/Order' || to.path === '/Home' || to.path === '/tishi' || to.path === '/guanyu' || to.path === '/hezuo' || to.path === '/tgxq'){
    next();
  }else if(to.path === '/zhuye'){
    if (window.localStorage.getItem("dengru")){
      next();
    }else {
      next('/dengru')
    }
  }else if(to.path === '/dingdan'){

    if (window.localStorage.getItem("yhxx")){
      next();
    }else {
      alert("您还没有登入哦！")
      next('/Home')
    }
  }

});

export default router
